type DataType = 'number' | 'boolean' | 'string' | 'object';

export const validateDataType = (data: any, type: DataType) => {
  switch (type) {
    case 'number':
      return typeof data === 'number';
    case 'boolean':
      return typeof data === 'boolean';
    case 'string':
      return typeof data === 'string';
    case 'object':
      return typeof data === 'object' && !Array.isArray(data);
    default:
      return false; // Invalid type
  }
};

export const convertDataType = (value: any, type: DataType) => {
  switch (type) {
    case 'number':
      return parseInt(value);
    case 'boolean':
      return value === 'true' ? true : value === 'false' ? false : Boolean(value);
    case 'string':
      return value;
    case 'object':
      return value;
    default:
      return false; // Invalid type
  }
};

export const getDataType = (value: any) => {
  if (validateDataType(value, 'number')) {
    return 'number';
  } else if (validateDataType(value, 'boolean')) {
    return 'boolean';
  } else if (validateDataType(value, 'object')) {
    return 'object';
  } else return 'string';
};
